export default "__VITE_ASSET__BertDV60__"